<!--
 * @Author: your name
 * @Date: 2021-11-17 14:43:15
 * @LastEditTime: 2021-11-17 15:45:32
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \team-web\src\components\hideBox\button\im.vue
-->
<!-- 交流 -->
<template>
  <div class="button">
    <div @click.stop="toChat(item)">
      <img style="width:20px;height:20px" src="@/assets/hideBox/jiaoliu.png" alt />
      <span>交流</span>
    </div>
  </div>
</template>

<script>
import axios from "@/http"
import { apiWorker } from "@/api/apiWorker"
import eventBus from "@/utils/event-bus"
import {checkDataStatusMessage} from "@/utils/checkDataStatus"

export default {
  name: "im",
  inject:['cardListCom'],
  props:{
    item:Object
  },
  data(){
    return {
      loading:false
    }
  },
  methods:{
    // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6 劳务用工 7班组找活
    async toChat(item) {
      //做登录校验
      if(this.permissionTips({realName:![1, 2, 3, 4, 5, 6].includes(Number(this.$parent.type))}))return
      //做数据有效性校验
      let no = this.item.no
      if(this.$parent.type==2){no = this.item.companyNo}
      const dataState = await checkDataStatusMessage.call(this,this.$parent.type,no)
      if (!dataState || dataState != 1) {return}
      if (item.companyNo === this.$parent.companyNo||(item.teamNo&&item.teamNo === this.$parent.teamNo)||item.teamRoleNo === this.$parent.teamNo) {
        this.$message.error("操作失败，不能对同企业/团队发布的内容进行该操作")
        return
      }
      if (item.userNo === this.$parent.userNo ||item.user_no === this.$parent.userNo||item.createUserNo === this.$parent.userNo) {
        this.$message.error("操作失败，不能对自己发布的内容进行该操作")
        return
      }else if (item.imId) {//发布时选择了客服人员
        if (this.$parent.type == 7) {
          eventBus.$emit("sendImMessage", item.imId)
        } else {
          axios.get(`${process.env.VUE_APP_COMPANY}/v1/organization/getUser/${item.imId}`)
            .then(res => {
              if (res.data.code === 200) {
                if (res.data.data.imAccount) {
                  eventBus.$emit("sendImMessage", res.data.data.imAccount)
                } else {
                  this.$message.error("未找到客服人员")
                }
              } else {
                this.$message.error(res.data.msg)
              }
            })
        }
      } else if (item.userNo && !item.imId) {//未选择就与发布人交流
        let { data } = await apiWorker.getfindUserByNo(item.userNo)
        if (data.code === 200) {
          if (data.data.imAccount) {
            eventBus.$emit("sendImMessage", data.data.imAccount)
          } else {
            this.$message.error("未找到客服人员")
          }
        } else {
          this.$message.error(data.msg)
        }
      } else {
        if (this.$parent.type == 2) {
          this.$message.error("功能正在开发中")
          return
        }
        this.$message.error("未找到客服人员")
      }
    }
  }
}
</script>

<style scoped>
</style>
